module.exports = __webpack_public_path__ + "static/img/2019年公司网站-首页-01.3665b99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2019年公司网站-首页-01.png
// module id = 7u9L
// module chunks = 14